import { render, staticRenderFns } from "./OrganizationContactSecurityRolesForm.vue?vue&type=template&id=2e974228&"
import script from "./OrganizationContactSecurityRolesForm.vue?vue&type=script&lang=js&"
export * from "./OrganizationContactSecurityRolesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports